import Vue from "vue";
import Loading from "./sira/Loading.vue";

Vue.component("Loading", Loading);

let components = [
  "BatchSummary",
  "EvaluatedBrand",
  "EvaluatedReceivedLost",
  "EvaluationApollo",
  "EvaluationDealership",
  "EvaluationGroup",
  "EvaluationMonth",
  "EvaluationSeller",
  "EvaluationSummary",
  "Painel",
  "ReceivedBrand",
  "ReceivedSeller",
  "StackedBars"
];

for (let component of components) {
  Vue.component(component, () => import(`./sira/${component}.vue`));
}
